import { ExplorerConfig } from 'codeArt/components/Explorer';


export const DomainConfig = {
  // www: "https://www.gotiny.cn",
  // file: "https://file.gotiny.cn",
  // main: "https://a-rpc.gotiny.cn",
  // su: "https://su.gotiny.cn",
  // poster: "https://poster.gotiny.cn",
  request: {
    // personal: "https://p-rpc.gotiny.cn"
    personal: "https://harpc.wowdb.cc"
  },
  // help: "https://docs.gotiny.cn"
}

/* export const DomainConfig = {
  www: "http://test-www.gotiny.cn:1515",
  file: "http://test-file.gotiny.cn:1514",
  main: "http://test-a-rpc.gotiny.cn:1513",
  su: "http://test-su.gotiny.cn:1516",
  request: {
    marketer: "http://test-m-rpc.gotiny.cn:1511",
    personal: "http://test-p-rpc.gotiny.cn:1512"
  },
  help: "http://docs.gotiny.cn"
} */

ExplorerConfig.set({
  domain: DomainConfig.file,
  getItems: "/getExplorerItems",
  createDirectory: "/createDirectory",
  "delete": "/deleteExplorerItems",
  rename: "/renameExplorerItem",
  moveFiles: "/moveFiles",
  getRootDirectory: "/getRootDirectory",
  getVirtualDirectory: "/getVirtualDirectory",
});



export const Events = {
  memberRequestWaitingCountChanged: 1,
  issueChanged: 2,
  principalChanged: 3,
  taskChanged: 4,
  paperChanged: 5,
  leanCanvasChanged: 6, //精益画布更新了
  leanCanvasDirectionChanged: 7,
  opponentChanged: 8,
  competitorChanged: 9,
  userRoleChanged: 10,
  posterChanged: 11,
  posterTemplateChanged: 12,
  posterThemeChanged: 13,
  userStoryChanged: 14,
  kanbanChanged: 15,
  workflowChanged: 16,
  kanbanHeedChanged: 17,
  onlineTaskChanged: 18,
  userProblemChanged: 19,
  KFChanged: 20,
  marketerChanged: 21,
  contactPersonChanged: 22,
  productModuleChanged: 23,
  productFunctionChanged: 24,
  growChanged: 25,
  rmgtChanged: 26,
  objectiveChanged: 27,
  objectiveDeleted: 28,
}